import React from 'react';
import { Button } from './ui/button';
import { Check } from 'lucide-react';

const Pricing = () => {
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const features = [
    'Instructed by experienced driver',
    '1-on-1 tuition',
    'Real car on real road surface',
    'Photo opportunity included',
    'Insurance included',
  ];

  return (
    <section id="pricing" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-bold text-[hsl(210,100%,12%)] mb-4">Your First Drive</h2>
          <p className="text-lg text-gray-700">Everything you need to get started—one clear price, no hidden extras.</p>
        </div>

        <div className="max-w-md mx-auto">
          <div className="bg-gradient-to-br from-white to-blue-50 rounded-3xl p-8 md:p-10 border-2 border-[hsl(210,100%,45%)] relative overflow-hidden shadow-2xl">
            <div className="absolute top-0 left-0 right-0 h-2 bg-gradient-to-r from-[hsl(210,100%,45%)] to-[hsl(180,80%,45%)]"></div>
            
            <div className="flex flex-col items-center text-center mb-8">
              <div className="text-[hsl(210,100%,45%)] text-sm font-bold uppercase tracking-wide mb-3">
                Kyle Drive First Session
              </div>
              <div className="text-6xl font-bold text-[hsl(210,100%,12%)] mb-3 leading-none">
                £39.99
              </div>
              <div className="text-gray-600 font-medium text-base">per session · 30 minutes</div>
            </div>

            <div className="space-y-4 mb-8 max-w-sm mx-auto">
              {features.map((feature, index) => (
                <div key={index} className="flex items-center gap-3 justify-start">
                  <div className="flex-shrink-0 w-6 h-6 rounded-full bg-gradient-to-br from-[hsl(210,100%,45%)] to-[hsl(180,80%,45%)] flex items-center justify-center">
                    <Check className="w-4 h-4 text-white" />
                  </div>
                  <span className="text-gray-700 font-medium text-left">{feature}</span>
                </div>
              ))}
            </div>

            <Button
              onClick={() => scrollToSection('book')}
              className="w-full bg-gradient-to-r from-[hsl(210,100%,45%)] to-[hsl(180,80%,45%)] hover:from-[hsl(210,100%,40%)] hover:to-[hsl(180,80%,40%)] text-white py-6 text-lg shadow-xl font-semibold"
            >
              Book Now
            </Button>

            <p className="text-center text-sm text-gray-500 mt-6">Gift vouchers coming soon!</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;